import React, {FC, useEffect, useState} from 'react';

import {t} from "i18next";
import { v4 as uuidv4 } from 'uuid';
import {createSelector} from "reselect";
import {RootState} from "../../../redux/store";
import {useAppSelector} from "../../../redux/hooks";
import FormSelect, {ISelectOption} from "../../commons/Select/FormSelect";
import getFrequencyBySla from './FrequencyHelper';
import Tooltip from "../../Tooltip/Tooltip";

interface FrequencySelectorProps {
  data: number|null
  onChange: (frequncy: number) => void
}

const memoizedSelector = createSelector(
    (state: RootState) => state.sellers.currentSeller,
    (currentSeller) => ({ currentSeller })
);

export const FrequencySelector: FC<FrequencySelectorProps> = ({
  data,
  onChange
}) => {

  const { currentSeller } = useAppSelector(memoizedSelector)

  const defaultUpdateFrequency = 0

  const [availableUpdateFrequencies, setAvailableUpdateFrequencies] = useState<{[key: number]: string}>({});
  const [fieldId] = useState("frequency_selector_" + uuidv4());
  const [updateFrequency, setUpdateFrequency] = useState(defaultUpdateFrequency);
  const [updateFrequencySelectorOptions, setUpdateFrequencySelectorOptions] = useState<ISelectOption[]>([]);

  useEffect(() => {

    const frequencyBySla: number = getFrequencyBySla(currentSeller.info.data?.sla || '')
    availableUpdateFrequencies[frequencyBySla] = t(`Update every ${frequencyBySla} minutes`, {ns: "messages"})
    setAvailableUpdateFrequencies(availableUpdateFrequencies)

    const selectOptions: ISelectOption[] = []
    for (const key in availableUpdateFrequencies) {
      selectOptions.push({text: availableUpdateFrequencies[key], value: key})
    }
    setUpdateFrequencySelectorOptions(selectOptions)

    if (!data) {
      data = frequencyBySla
      onChange(frequencyBySla)
    }
  }, [])

  useEffect(() => {
    if (!data) {
      return
    }

    // @ts-ignore
    const updateFrequency = data
    setUpdateFrequency(updateFrequency)

    // Adding an item to the list of selector options if updateFrequency is not in the list for some reason
    let isOptionsIncludeValue = availableUpdateFrequencies.hasOwnProperty(updateFrequency);

    if (!isOptionsIncludeValue) {
      availableUpdateFrequencies[updateFrequency] = t(`Update every ${updateFrequency} minutes`, {ns: "messages"});
      setAvailableUpdateFrequencies(availableUpdateFrequencies)

      const updateFreqAsSelectorOption = updateFrequency.toString()
      updateFrequencySelectorOptions.push({text: updateFreqAsSelectorOption, value: updateFreqAsSelectorOption})
      setUpdateFrequencySelectorOptions(updateFrequencySelectorOptions)
    }

  }, [data])

  useEffect(() => {
    onChange(updateFrequency)
  }, [updateFrequency])

  const customInputClassName = 'border-[#E2E8F0] mb-1 px-3 py-2 rounded-md text-sm shadow-sm placeholder-slate-400  w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'

  function updateFrequencyHandler(e: any): void {
    setUpdateFrequency(parseInt(e.target.value))
  }

  return (
      <>
        <label
            className="block flex text-gray-600 text-left font-medium mb-1 text-sm items-center"
             htmlFor={fieldId}
        >
          <span>{t<string>("Загружать обновления", { ns: "messages" })}</span>
          <Tooltip title={'Изменить можно через поддержку'}>
            <svg className="ml-3 w-4 h-4 fill-current text-gray-400" viewBox="0 0 16 16">
              <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" />
            </svg>
          </Tooltip>
        </label>
        <FormSelect
          id={fieldId}
          name={fieldId}
          value={updateFrequency}
          label={false}
          changeHandler={updateFrequencyHandler}
          customClassName={customInputClassName}
          blurHandler={updateFrequencyHandler}
          validationError={false}
          validationErrorDescription={''}
          options={updateFrequencySelectorOptions}
          require={false}
      ></FormSelect>
      </>

  );
};
